<template>
  <div id="app">
  	<img id="header" alt="Galek login" src="@/assets/logopolskagrupait.png"/>
  	<LoginContent/>
  	<img id="footer" alt="Galek login" src="@/assets/logopolskagrupaitfull.png"/>
    <fullscreen class="fullscreen-wrapper" v-model="fullscreen">
    </fullscreen>
    <div class="fs-box">
    <button class="fullscrbtn" type="button" @click="toggleApi" >{{btnTitle}}</button>
    </div>
  </div>
</template>

<script>
import LoginContent from "@/components/LoginContent";
import VueFullscreen from 'vue-fullscreen'
  import Vue from 'vue'
  Vue.use(VueFullscreen)

export default {
  name: 'App',
  components: {
	LoginContent,
  },
  data() {
    return {
      fullscreen: false,
      btnTitle: 'Pełny ekran'
    }
  },
  watch:{
    fullscreen(){
      if(this.fullscreen === false){
        this.btnTitle = 'Pełny ekran'
      }
      else{
        this.btnTitle = 'Pełny ekran'
      }
    }
  },
  methods: {
    toggle () {
      this.fullscreen = !this.fullscreen
      console.log(this.btnTitle)
    },
    toggleApi () {
      this.$fullscreen.toggle()
      this.fullscreen = !this.fullscreen
      console.log(this.btnTitle)
    },
  },
}
</script>

<style>
body, html{
    background: white;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
#header {
  width:100px;
  height:100px;
}

#footer {
  margin-top:100px;
}
.fullscreen-wrapper {
  width: 100%;
  height: 100%;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
  }
.fullscrbtn{
  	color: #FFFFFF;
    background-color: royalblue;
    width: 200px;
    height: 40px;
    float: center;
}
@media screen and (max-width: 1024px){
.fs-box{
    position:fixed;
    bottom: 60px;
    width: 100%;
}
}
@media screen and (min-width: 1025px){
.fs-box{
    display: none;
    position:fixed;
    bottom: 60px;
    width: 100%;
}
}

</style>



// WEBPACK FOOTER //
// src/components/Login.vue